module.exports = __vendor;


//////////////////
// WEBPACK FOOTER
// external "__vendor"
// module id = 8
// module chunks = 0